/* eslint-disable no-undef */

export default {
	name: "modal-form",
	props: ["heading", "modalId", "isSaving", "showModal"],
	emits: ["closeClicked", "saveButtonClicked"],
	data() {
		return {
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false
		};
	},
	methods: {
		onModalCloseClick() {
			this.$emit("closeClicked", true);
		},
		onModalSaveClick(){
			this.$emit("saveButtonClicked", true);
		}
	},
	mounted: function () {
        
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		isSaving: {
			handler: function () {
				if(this.isSaving !== null && this.isSaving !== undefined){
					this.formIsSaving = this.isSaving;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal({backdrop: 'static', keyboard: false});
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};
